import { Base64Url, BitLength, SegmentEncoder, SegmentSequence, SemanticPreEncoder, } from './encoder/index.js';
import { SegmentIDs } from './model/index.js';
import { IntEncoder } from './encoder/field/IntEncoder.js';
import { TCModel } from './TCModel.js';
/**
 *
 *
 */
export class TCString {
    /**
 *
 *
 *
 *
 *
 */
    static encode(tcModel, options) {
        let out = '';
        let sequence;
        tcModel = SemanticPreEncoder.process(tcModel, options);
        /**
 *
 */
        if (Array.isArray(options?.segments)) {
            sequence = options.segments;
        }
        else {
            sequence = new SegmentSequence(tcModel, options)['' + tcModel.version];
        }
        sequence.forEach((segment, idx) => {
            let dotMaybe = '';
            if (idx < sequence.length - 1) {
                dotMaybe = '.';
            }
            out += SegmentEncoder.encode(tcModel, segment) + dotMaybe;
        });
        return out;
    }
    /**
 *
 *
 *
 *
 *
 *
 *
 *
 */
    static decode(encodedTCString, tcModel) {
        const segments = encodedTCString.split('.');
        const len = segments.length;
        if (!tcModel) {
            tcModel = new TCModel();
        }
        for (let i = 0; i < len; i++) {
            const segString = segments[i];
            /**
 *
 *
 *
 *
 *
 */
            const firstChar = Base64Url.decode(segString.charAt(0));
            const segTypeBits = firstChar.substr(0, BitLength.segmentType);
            const segment = SegmentIDs.ID_TO_KEY[IntEncoder.decode(segTypeBits, BitLength.segmentType).toString()];
            SegmentEncoder.decode(segString, tcModel, segment);
        }
        return tcModel;
    }
}
